<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">设置人脸属性</h1>
        <h3 class="doc_main_h3">（1）设置名字</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的名字属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceSetPersonName(String PersonID, String PersonName);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）PersonID：人员ID</p>
        <p class="doc_main_p">（2）PersonName：人员姓名</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int类型，0：设置成功。返回其他：设置失败。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int setName = skFace.SKFaceSetPersonName("203423","田某某");</code></pre>
        <h3 class="doc_main_h3">（2）设置性别</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的性别属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceSetPersonSex(String PersonID, int PersonSex);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）PersonID：人员ID</p>
        <p class="doc_main_p">（2）PersonSex：人员性别，1：女，2：男，其他无效</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int类型，0：设置成功。返回其他：设置失败。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"> int setSex = skFace.SKFaceSetPersonSex("203423",1);</code></pre>
        <h3 class="doc_main_h3">（3）设置生日</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的生日属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceSetPersonBirthday(String PersonID, int BirthYear, int BirthMonth, int BirthDay);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）PersonID：人员ID</p>
        <p class="doc_main_p">（2）BirthYear：人员生日-年份</p>
        <p class="doc_main_p">（3）BirthMonth：人员生日-月份</p>
        <p class="doc_main_p">（4）BirthDay：人员生日-哪天</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int类型，0：设置成功。返回其他：设置失败。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int setBirthday = skFace.SKFaceSetPersonBirthday("203423",1994,9,27);</code></pre>
        <h3 class="doc_main_h3">（4）设置细节</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据人员的ID修改该人员的细节信息属性（其他备注信息）。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceSetPersonDetailsInfo(String PersonID, String DetailsInfo);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）PersonID：人员ID</p>
        <p class="doc_main_p">（2）DeatilsInfo：人员细节信息（其他备注信息）</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int类型，0：设置成功。返回其他：设置失败。</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int setDetails = skFace.SKFaceSetPersonDetailsInfo("203423", ”盛开互动”);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','本地接口','设置人脸属性'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/localfacemanagement/SettingFaceProperties.vue